import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "..";
import findUserName from "./finsUserName";

const readComments = async (whiskeyId) => {

    const q = query(collection(db, "comments"),where("whiskeyId", "==", whiskeyId));
    const comments = []
    let _fullName
    const querySnapshot = await getDocs(q);
    for (const doc of querySnapshot.docs) {
            _fullName = await findUserName(doc.data().userId)
            comments.push({ id: doc.id, comment: doc.data().comment, fullName: _fullName.user.fullName, created: doc.data().created, userId: doc.data().userId })
    };
    return comments
}

export default readComments